import { z } from 'zod';
// ---- Mapping ------------------------------------------------------------
export const contactImportField = z.enum([
    'salutation',
    'firstName',
    'lastName',
    'role',
    'department',
    'email',
    'phone',
    'mobile',
    'notes',
    // Falls die Datei eine Kunden-Spalte enthält — sonst nutzt der Server
    // den im Commit-Request hinterlegten customerId-Fallback.
    'customerName',
]);
export const REQUIRED_CONTACT_FIELDS = ['firstName', 'lastName'];
/** Mapping: Contact-Feld → Spaltenname aus der Datei. */
export const contactImportMapping = z.record(contactImportField, z.string()).default({});
// ---- Commit -------------------------------------------------------------
export const importCommitRequest = z.object({
    target: z.literal('contact'),
    /** Fallback-Kunde für alle Zeilen ohne customerName-Mapping. */
    defaultCustomerId: z.number().int().positive().optional(),
    /** Spaltennamen aus dem Parse-Result, in derselben Reihenfolge wie die rows. */
    columns: z.array(z.string()).min(1),
    mapping: contactImportMapping,
    /** Header-Reihe ist NICHT enthalten — nur Datenzeilen. */
    rows: z.array(z.array(z.union([z.string(), z.number(), z.null()]))),
    /** Wenn true: Zeilen mit gleicher (customerId + email) werden übersprungen. */
    skipDuplicates: z.boolean().default(true),
});
